import { render, staticRenderFns } from "./RetentionSummaryV2.vue?vue&type=template&id=18622994&scoped=true"
import script from "./RetentionSummaryV2.vue?vue&type=script&lang=js"
export * from "./RetentionSummaryV2.vue?vue&type=script&lang=js"
import style0 from "./RetentionSummaryV2.vue?vue&type=style&index=0&id=18622994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@6.8.1_vue-template-compiler@2.6.14_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18622994",
  null
  
)

export default component.exports